import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useAuth } from '../auth/AuthContext';
import { ADMIN_REFRESH_DAILY_ROLLUP } from '../graphql/adminQueries';

/**
 * Admin-only control that recomputes admin_daily_metrics for today UTC + 27 prior days.
 */
export default function RefreshRollupButton({ onRefreshed, onMessage }) {
  const { isAdmin: canMutate } = useAuth();

  const [refreshRollup, { loading }] = useMutation(ADMIN_REFRESH_DAILY_ROLLUP, {
    onCompleted: async (data) => {
      const result = data?.adminRefreshDailyRollup;
      if (result?.success) {
        const day = result.latestRollupDate
          ? String(result.latestRollupDate).slice(0, 10)
          : 'today';
        onMessage?.(`Rollup refreshed through ${day} (${result.processed ?? 0} days).`);
        if (onRefreshed) await onRefreshed();
      } else {
        onMessage?.('Refresh completed but rollup may still be stale.');
      }
    },
    onError: (mutationError) => {
      onMessage?.(mutationError.message || 'Daily rollup refresh failed.');
    },
  });

  if (!canMutate) return null;

  return (
    <button
      type="button"
      className="primary-button"
      onClick={() => {
        onMessage?.(null);
        refreshRollup();
      }}
      disabled={loading}
    >
      {loading ? 'Refreshing rollup…' : 'Refresh rollup'}
    </button>
  );
}

export function useRollupRefreshMessage() {
  const [message, setMessage] = useState(null);
  return [message, setMessage];
}
